import { autoinject, containerless, bindable } from "aurelia-framework";
import { IAutoCompleteEntity, GetAutoCompleteDataFunc } from "../../../../../types/custom";
import * as Awesomplete from "awesomplete";
import { Subscription, EventAggregator } from "aurelia-event-aggregator";
import { ApiService } from "../../../services/api";
import { Selected } from "../../../model/selected";

@containerless
@autoinject
export class AutoCompleteCustomElement {
	@bindable id: string;
	@bindable label: string;
	@bindable labelClass: string;
	@bindable class: string;
	@bindable placeholder: string = '';
	@bindable autoFocus: boolean;
	@bindable value: any;
	@bindable disabled: boolean;
	// restrict to available choices
	@bindable restricted: boolean = false;
	@bindable getdata: GetAutoCompleteDataFunc;
	// Awesomplete properties
	@bindable minChars: number = 2;
	@bindable maxItems: number = 14;
	@bindable autoFirst: boolean = false;
	// multi select
	@bindable selected: Selected<any>;

	awe: Awesomplete;
	inputElem: HTMLInputElement;
	labelElem: HTMLLabelElement;

	items: IAutoCompleteEntity[];

	constructor(private _api: ApiService, private _ea: EventAggregator, public element: Element) { }

	private _clear: Subscription;

	attached() {
		this._initAwesomeplete();
		this._clear = this._ea.subscribe("clear", (ids: string[]) => {
			if (ids.indexOf(this.id) >= 0) {
				this.value = undefined;
			}
		});

		if (this.autoFocus)
			this.inputElem.focus();
	}

	detached() {
		this.inputElem.removeEventListener('awesomplete-select', this._aweSelected);
		this._clear.dispose();
	}

	context;
	bind(context, overrideContext) {
		this.context = context;
	}

	private _initAwesomeplete() {
		this.awe = new Awesomplete(this.inputElem, { autoFirst: Boolean(this.autoFirst), minChars: Number(this.minChars), maxItems: this.maxItems });

		this.inputElem.addEventListener('awesomplete-select', this._aweSelected.bind(this));
	}

	private _down(e: KeyboardEvent) {
		switch (e.key) {
			case "ArrowDown":
				if (this.awe.ul.childNodes.length === 0 || this.awe.ul.hasAttribute('hidden')) {
					this._getAutocompleteData();
					return;
				}
		}
		return true;
	}

	private _focus(focused: boolean) {
		if (focused)
			this.labelElem.classList.add('active');
		else
			this.labelElem.classList.remove('active');
		if (!focused && this.restricted && this.items && this.items.find((elem) => elem.value === this.value) == undefined)
			this.value = undefined;
	}

	private _aweSelected(event) {
		this.value = event.text.value;

		let selected = this.items.find((elem) => elem.value === this.value);

		if (this.selected) {
			this.selected.select(selected.data);
			this.value = undefined;
		}

		// Dispatch awesomplete 'selected' event
		this.element.dispatchEvent(new CustomEvent('autocomplete-selected', { detail: { label: selected.label, value: selected.value, data: selected.data } }));
	}

	private _getAutocompleteData() {
		this.getdata(this.value)
			.then((res: IAutoCompleteEntity[]) => {
				this.items = res;

				this.awe.list = res;
				this.awe.evaluate();
			})
			.catch((err) => {
				console.log(err);
			});
	}
}
